/* The look of the hand-rolled native-<dialog> `Modal` this replaced, so the
   dialogs moved onto base-ui (log out, install, subscribe, about, padi's
   sign-up) look as they did. Unlayered, so it wins over DialogContent's
   Tailwind defaults (grid + gap, p-6, sm:max-w-lg); a caller's own class
   raises specificity with `[data-slot='dialog-content'].x` to win over this.
   overflow/max-height mirror the browser's own `dialog:modal` defaults. */
.card {
	z-index: 1000;
	display: block;
	gap: 0;
	width: 360px;
	max-width: 20rem;
	height: 300px;
	max-height: calc(100% - 2rem);
	overflow: auto;
	overscroll-behavior: contain;
	padding: 2rem;
	border: 0;
	border-radius: 0.5rem;
	box-shadow: 0 0 0.5rem 0.25rem hsl(0 0% 0% / 10%);
}

.backdrop {
	z-index: 1000;
	background: hsl(0 0% 0% / 80%);
}
